import { render } from "./FolderRowActions.vue?vue&type=template&id=fab16ebc&scoped=true"
import script from "./FolderRowActions.vue?vue&type=script&lang=js"
export * from "./FolderRowActions.vue?vue&type=script&lang=js"

import "./FolderRowActions.vue?vue&type=style&index=0&id=fab16ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fab16ebc"]])

export default __exports__